/**
 * @generated SignedSource<<22eadcf443d08349c1fac3c8e23b982e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserStatType = "COMMUNITY" | "GAMES_PLAYED" | "GAMES_WON" | "STRICT_WAGER" | "WAGER" | "%future added value";
export type DevChangeUserStatValueInput = {
  key: UserStatType;
  value: number;
};
export type AppComponentDevChangeUserStatValueMutation$variables = {
  input: DevChangeUserStatValueInput;
};
export type AppComponentDevChangeUserStatValueMutation$data = {
  readonly devChangeUserStatValue: {
    readonly user: {
      readonly uuid: string | null;
      readonly userStats: ReadonlyArray<{
        readonly name: string;
        readonly value: number;
        readonly meta: any | null;
      }>;
    };
  } | null;
};
export type AppComponentDevChangeUserStatValueMutation = {
  variables: AppComponentDevChangeUserStatValueMutation$variables;
  response: AppComponentDevChangeUserStatValueMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DevChangeUserStatValuePayload",
    "kind": "LinkedField",
    "name": "devChangeUserStatValue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserStat",
            "kind": "LinkedField",
            "name": "userStats",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "meta",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppComponentDevChangeUserStatValueMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppComponentDevChangeUserStatValueMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "292cdebd7e1de986b3110a2671036028",
    "id": null,
    "metadata": {},
    "name": "AppComponentDevChangeUserStatValueMutation",
    "operationKind": "mutation",
    "text": "mutation AppComponentDevChangeUserStatValueMutation(\n  $input: DevChangeUserStatValueInput!\n) {\n  devChangeUserStatValue(input: $input) {\n    user {\n      uuid\n      userStats {\n        name\n        value\n        meta\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb5db95067e53de47280229e8ae12970";

export default node;
